import { getAttr, getEntityId } from '../../../../features/helpers/apiHelpers';

export const mapCityArea = (translator) => (cityArea) => {
  return {
    title: getAttr(cityArea, 'name'),
    status: getAttr(cityArea, 'isActive')
      ? translator('global.active')
      : translator('global.inactive'),
    numberOfHearings: getAttr(cityArea, 'numOfHearings'),
    key: getEntityId(cityArea),
  };
};
